<template>
	<div class="banner-top-container container">
		<div class="tips">
			<v-icon>check</v-icon>
			<span>Aumentarás tus ventas, fidelizarás a tus clientes y evitarás más contagios. </span>
		</div>
		<div class="tips">
			<v-icon>check</v-icon>
			<span>Es 100% personalizado a tu negocio: con tu marca y logo. </span>
		</div>
		<div class="tips">
			<v-icon>check</v-icon>
			<span>Muy sencillo de usar para ti y tus clientes de siempre.</span>
		</div>
	</div>
</template>
<script>
export default {
	name: 'banner-top',
};
</script>
<style lang="scss" scoped>
.banner-top-container {
	align-items: center;
	display: flex;
	height: 92px;
	justify-content: space-evenly;
	padding: 5px 20px;

	@media (max-width: 600px) {
		flex-wrap: wrap;
		height: auto;
	}

	.tips {
		align-items: center;
		border: 1px solid color(green-link);
		color: color(title-green);
		display: flex;
		font-family: font(lato-regular);
		font-size: size(medium);
		height: 56px;
		justify-content: flex-start;
		padding: 0 22px;
		width: 320px;

		@media (max-width: 768px) {
			font-size: size(small10);
		}

		@media (max-width: 600px) {
			border: 1px solid color(green-link);
			height: 52px;
			font-size: size(medium);
			margin-bottom: 3px;
		}

		@media (max-width: 340px) {
			font-size: size(small10);
		}
	}

	.icon {
		border: 1px solid color(green-link);
		border-radius: 50%;
		color: color(green-link);
		font-size: size(medium18);
		height: 20px;
		margin-right: 14px;
		width: 20px;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/home/banner-top.vue